import { createContext, useState, useMemo, useContext, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useSettings } from "src/hooks/use-settings";
import { createTheme } from "src/theme";

const ThemeModeContext = createContext();

export const ThemeModeProvider = ({ children }) => {
  const settings = useSettings();
  const [mode, setMode] = useState("light");

  const toggleMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    const metaTag = document.querySelector('meta[name="color-scheme"]');
    if (metaTag) {
      metaTag.setAttribute("content", mode);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.name = "color-scheme";
      newMetaTag.content = mode;
      document.head.appendChild(newMetaTag);
    }
  }, [mode]);

  const theme = useMemo(
    () =>
      createTheme({
        colorPreset: settings.colorPreset,
        contrast: settings.contrast,
        direction: settings.direction,
        paletteMode: mode,
        responsiveFontSizes: settings.responsiveFontSizes,
      }),
    [mode, settings]
  );

  return (
    <ThemeModeContext.Provider value={{ mode, toggleMode }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeModeContext.Provider>
  );
};

// export const useThemeMode = () => useContext(ThemeModeContext);

export const useThemeMode = () => {
  const context = useContext(ThemeModeContext);
  if (!context) {
    throw new Error("useThemeMode must be used within a ThemeModeProvider");
  }
  return context;
};
